
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import AdminLayout from "@/layouts/AdminLayout"
import MonthlyPromptsSection from "@/components/prompts/MonthlyPromptsSection"
import TierPromptsSection from "@/components/prompts/TierPromptsSection"
import MonthlyTierPromptsSection from "@/components/prompts/MonthlyTierPromptsSection"

export default function ManagePrompts() {
  return (
    <AdminLayout title="Manage Prompts">
      <Tabs defaultValue="monthly-tier" className="w-full space-y-6">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="monthly-tier">Monthly Tier Prompts</TabsTrigger>
          <TabsTrigger value="monthly">Monthly Prompts</TabsTrigger>
          <TabsTrigger value="tier">Tier Prompts</TabsTrigger>
        </TabsList>
        
        <TabsContent value="monthly-tier">
          <MonthlyTierPromptsSection />
        </TabsContent>

        <TabsContent value="monthly">
          <MonthlyPromptsSection />
        </TabsContent>

        <TabsContent value="tier">
          <TierPromptsSection />
        </TabsContent>
      </Tabs>
    </AdminLayout>
  )
}
